import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {base64Encode, QueryStore, Store} from '@softline/core';
import {RdpLogAppStore, SOFTLINE_FEATURE_RDP_LOG_APP} from '../../rdp-log.shared';

import {BackNavigable, BackNavigationService} from '@softline/application';

import { DateInputComponent } from '@softline/ui-core/date-input';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-search',
    imports: [ReactiveFormsModule,
    DateInputComponent,
    TranslatePipe],
    templateUrl: './search.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnDestroy, BackNavigable {

  form = this.fb.group({
    from: [''],
    to: ['']
  });

  constructor(private fb: UntypedFormBuilder,
              private router: Router,
              private store: Store,
              private backNavigationService: BackNavigationService) { }

  ngOnInit(): void {
    this.backNavigationService.set(this);
    this.store.observe(SOFTLINE_FEATURE_RDP_LOG_APP, QueryStore.getters.query.query).subscribe(
      o => this.form.patchValue(o as object ?? {})
    );
  }

  ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/rdp-log']);
  }

  async onSubmit(): Promise<void> {
    await this.router.navigate(['/rdp-log'], {queryParams: {query: base64Encode(JSON.stringify(this.form.value))
  }});
  }

}
